// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"_3w4TRAe5","HeaderTransparent":"_1ARB565l","button":"_1jdhTGnc","Header":"_1TyFikDZ","headerBoxShadow":"_318jvIfT","LogoBlock":"_30MtjI6p","navLinksContainer":"_27uzUUHq","navLink":"_1XXNTPMl","activeNavLink":"_2ef4K_c3","darkLogo":"_1clyf_JP","NavDropdown":"_2x5z53y7","NavHamburger":"x6B2H92p","seafoam":"_3i9bPcpX","NavBlock":"_2PrwsbFM"};
    if(module.hot) {
      // 1754514919735
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  